import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-480be10f")

_pushScopeId("data-v-480be10f")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tickets")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Tickets")
const _hoisted_3 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "ion-text-center loading_spinner"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h2", null, "Non hai ticket assegnati.", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "ion-padding-horizontal ion-text-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", null, "Consulta i ticket di assistenza a te assegnati", -1)
const _hoisted_10 = { style: {"padding":"10px"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "Cliente:", -1)
const _hoisted_13 = { class: "ticket_info_container" }
const _hoisted_14 = { class: "ticket_date" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", { class: "font-bold" }, "Date:", -1)
const _hoisted_16 = { class: "ticket_status" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h3", { class: "font-bold" }, "Stato:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "Messaggio:", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "ion-text-center ion-margin-top font-bold" }, " Non hai ticket assegnati per oggi ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")
  const _component_ion_fab = _resolveComponent("ion-fab")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "primary"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                ($setup.tickets.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode(_component_ion_text, { color: "danger" }, {
                        default: _withId(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode(_component_ion_text, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", null, [
                          ($setup.tickets.length != 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                _createVNode(_component_ion_list, null, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.tickets, (ticket) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        key: ticket.tickets_id,
                                        onClick: ($event: any) => ($setup.openDetail(ticket.tickets_id)),
                                        button: "true",
                                        detail: ""
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withId(() => [
                                              _createVNode(_component_ion_text, { color: "primary" }, {
                                                default: _withId(() => [
                                                  _hoisted_12,
                                                  _createTextVNode(" " + _toDisplayString($setup.riferimentoCliente(ticket)), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode("div", _hoisted_13, [
                                                _createVNode("div", _hoisted_14, [
                                                  _hoisted_15,
                                                  _createTextVNode(" " + _toDisplayString($setup.dateFormat(ticket.tickets_assign_date)), 1)
                                                ]),
                                                _createVNode("div", _hoisted_16, [
                                                  _hoisted_17,
                                                  _createVNode(_component_ion_badge, {
                                                    color: $setup.statoTicket(ticket.tickets_status_id)
                                                  }, {
                                                    default: _withId(() => [
                                                      _createTextVNode(_toDisplayString(ticket.tickets_status_value), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color"])
                                                ])
                                              ]),
                                              _createVNode("h3", null, [
                                                _hoisted_18,
                                                _createTextVNode(" " + _toDisplayString($setup.parseHtmlEnteties(ticket.tickets_message)), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_19, [
                                _createVNode(_component_ion_text, { color: "danger" }, {
                                  default: _withId(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                })
                              ]))
                        ])
                      ])
                    ]))
              ])),
          _createVNode(_component_ion_fab, {
            horizontal: "end",
            vertical: "bottom",
            slot: "fixed"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_fab_button, {
                color: "success",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getTickets()))
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, { icon: $setup.refresh }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})